<template>
  <div class="leftBar">
    <v-drawer :direction="'left'" :width="'26%'">
      <div class="animated fadeInLeftBig dx">
        <!--
        <bar-card class="lefts lefts1" :bg="'border-new'">
          <g-title>产业概况</g-title>
          <div class="panelContent">
            <left-top />
          </div>
        </bar-card> -->
        <bar-card class="lefts lefts1" :bg="'border-new'">
          <g-title :bg="'pp'">产业概况</g-title>
          <div class="panelContent">
            <left-mid />
          </div>
        </bar-card>
        <bar-card class="lefts lefts2" :bg="'border-new'">
          <g-title :bg="'green'">数字农村</g-title>
          <div class="panelContent">
            <nycz-bh />
          </div>
        </bar-card>
        <!-- <bar-card class="lefts" :bg="'border-new'">
          <g-title :bg="'green'">各区/各行业农业产值占比</g-title>
          <div class="panelContent">
            <nycz-zb />
          </div>
        </bar-card> -->
        <!--
        <bar-card class="lefts" :bg="'border-new'">
          <g-title :bg="'green'">绿色生态农业</g-title>
          <div class="panelContent">
            <left-bot />
          </div>
        </bar-card> -->
      </div>
    </v-drawer>
  </div>
</template>

<script>
import gTitle from "../components/gTitle";
// import leftTop from "./leftBar/leftTop";
import leftMid from "./leftBar/leftMid";
// import leftBot from "./leftBar/leftBot";
import nyczBh from "./leftBar/nyczBh";
// import nyczZb from "./leftBar/nyczZb";
export default {
  components: {
    gTitle,
    // leftTop,
    // leftBot,
    leftMid,
    nyczBh,
    // nyczZb
  },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.dx
  height 100%
.panelContent
  height calc(100% - 39px)
  color #fff
.lefts
  margin-bottom 10px
  height calc(28.33% - 10px)
.lefts1
  height calc(38.33% - 10px)
.lefts2
  height calc(100% - 38.33% - 10px)
.leftBar
  >>>.side
    bottom 8px
@media (min-height 1400px)
  .leftBar
    >>>.side
      width 24% !important
</style>
